// material ui icons
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import AvTimerRoundedIcon from '@mui/icons-material/AvTimerRounded';
import BatteryCharging20RoundedIcon from '@mui/icons-material/BatteryCharging20Rounded';
import DataThresholdingRoundedIcon from '@mui/icons-material/DataThresholdingRounded';
import DeviceThermostatRoundedIcon from '@mui/icons-material/DeviceThermostatRounded';
import ElectricalServicesRoundedIcon from '@mui/icons-material/ElectricalServicesRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import HeatPumpRoundedIcon from '@mui/icons-material/HeatPumpRounded';
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';
import HvacRoundedIcon from '@mui/icons-material/HvacRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SensorsOffRoundedIcon from '@mui/icons-material/SensorsOffRounded';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import WaterDamageRoundedIcon from '@mui/icons-material/WaterDamageRounded';

const SEVERITY_COLORS = {
  Critical: '#B00020', // deep error red
  Major: '#D32F2F', // strong red
  Medium: '#F57C00', // deep orange
  Minor: '#FBC02D', // amber
  Trivial: '#388E3C', // muted green
  Information: '#1976D2', // structured blue
  Unknown: '#9e9e9e1e', // neutral grey
};

const SEVERITY_LEVEL_MAP = {
  Information: 1,
  Trivial: 2,
  Minor: 3,
  Medium: 4,
  Warning: 4,
  Major: 5,
  Critical: 6,
};

const severityIconMap = {
  Critical: <ErrorRoundedIcon sx={{ color: SEVERITY_COLORS.Critical }} />,
  Major: <ErrorRoundedIcon sx={{ color: SEVERITY_COLORS.Major }} />,
  Medium: <WarningRoundedIcon sx={{ color: SEVERITY_COLORS.Medium }} />,
  Minor: <WarningRoundedIcon sx={{ color: SEVERITY_COLORS.Minor }} />,
  Warning: <WarningRoundedIcon sx={{ color: SEVERITY_COLORS.Medium }} />,
  Information: <InfoRoundedIcon sx={{ color: SEVERITY_COLORS.Information }} />,
  Trivial: <InfoRoundedIcon />,
};

const alarmTypeIconMap = {
  TimeBetweenConsumption: <HourglassBottomRoundedIcon />,
  ConsumptionLevel: <InfoRoundedIcon />,
  SeepLeakage: <WaterDamageRoundedIcon />,
  SensorDown: <SensorsOffRoundedIcon />,
  ActivityTimer: <AvTimerRoundedIcon />,
  ExternalSensorDown: <SensorsOffRoundedIcon />,
  ThresholdLimit: <DataThresholdingRoundedIcon />,
  FastSensorDown: <SensorsOffRoundedIcon />,
  BurstLeakage: <WaterDamageRoundedIcon />,
  TemperatureDeviation: <DeviceThermostatRoundedIcon />,
  HeatingSystem: <HeatPumpRoundedIcon />,
  VentilationSystem: <HvacRoundedIcon />,
  CoolingSystem: <AcUnitRoundedIcon />,
  BillingMeter: <ReceiptLongRoundedIcon />,
  PowerDisaggregation: <ElectricalServicesRoundedIcon />,
  LowBattery: <BatteryCharging20RoundedIcon />,
  BaseloadDeviation: <SsidChartIcon />,
};

const alarmTypeMap = {
  1: <HourglassBottomRoundedIcon />,
  2: <InfoRoundedIcon />,
  3: <WaterDamageRoundedIcon />,
  4: <SensorsOffRoundedIcon />,
  5: <AvTimerRoundedIcon />,
  6: <SensorsOffRoundedIcon />,
  7: <DataThresholdingRoundedIcon />,
  8: <SensorsOffRoundedIcon />,
  10: <WaterDamageRoundedIcon />,
  12: <DeviceThermostatRoundedIcon />,
  13: <HeatPumpRoundedIcon />,
  14: <HvacRoundedIcon />,
  15: <AcUnitRoundedIcon />,
  16: <ReceiptLongRoundedIcon />,
  17: <ElectricalServicesRoundedIcon />,
  18: <BatteryCharging20RoundedIcon />,
  19: <ElectricalServicesRoundedIcon />,
  20: <InfoRoundedIcon />,
  21: <InfoRoundedIcon />,
  22: <InfoRoundedIcon />,
  23: <WaterDamageRoundedIcon />,
  24: <SsidChartIcon />,
  25: <SsidChartIcon />,
};

export {
  SEVERITY_COLORS,
  SEVERITY_LEVEL_MAP,
  severityIconMap,
  alarmTypeIconMap,
  alarmTypeMap,
};
